import {config} from '../config';

export default {
    getIsIlumaLeviaUsageEnabled: () => config.data.levia.isIlumaLeviaUsageEnabled,
    getIsLeviaConsumablesEnabled: () => config.data.levia.isLeviaConsumablesEnabled,
    getLeviaConsumablesIcons: () => config.data.levia.leviaConsumablesIcons,
    getEligibleForLeviaEnabled: (deviceType) => config.data.levia.eligibleForLeviaEnabled?.includes(deviceType),
};
